<template>
    <div class="alert-wrap" :class="positionClasses">
        <transition-group :name="transition" tag="div" v-for="(item, index) in notifications" :key="index">
            <div class="alert alert-white rounded" :class="item.typeObject" role="alert" :key="index">
                <button type="button" data-dismiss="alert" aria-hidden="true" class="close" @click="hide">×</button>
                <div class="icon floatLeft" style="width: 20px; margin-top: 2px;">
                    <i v-if="displayIcons" class="fa" :class="item.iconObject"></i>
                </div>
                <span style="line-height: 20px; margin-right: 10px;" v-html="item.message"></span>
            </div>
        </transition-group>
    </div>
</template>
<script>
    import {EventBus} from "../../../events";

    export default {
        props: {
            timeout: {
                type: Number,
                default: 5000
            },
            types: {
                type: Object,
                default: () => ({
                    base: 'alert',
                    success: 'alert-success',
                    danger: 'alert-danger',
                    warning: 'alert-warning',
                    info: 'alert-info'
                })
            },
            displayIcons: {
                type: Boolean,
                default: false
            },
            icons: {
                type: Object,
                default: () => ({
                    base: 'fa',
                    danger: 'fa-exclamation',
                    success: 'fa-check',
                    info: 'ion-information-circled',
                    warning: 'ion-alert-circled',
                })
            },
            position: {
                type: String,
                default: 'right'
            }
        },

        data: () => ({
            notifications: [],
        }),


        methods: {
            flash(message, type) {
                type = type === undefined ? 'info' : type;

                this.notifications.push({
                    message: message,
                    type: type,
                    typeObject: this.classes(this.types, type),
                    iconObject: this.classes(this.icons, type)
                });

                setTimeout(this.hide, this.timeout);
            },

            classes(propObject, type) {
                let classes = {};

                if (propObject.hasOwnProperty('base')) {
                    classes[propObject.base] = true;
                }
                if (propObject.hasOwnProperty(type)) {
                    classes[propObject[type]] = true;
                }

                return classes;
            },

            hide(item = this.notifications[0]) {
                let key = this.notifications.indexOf(item);
                this.notifications.splice(key, 1);
            }
        },

        computed: {
            positionClasses() {
                let classes = [];

                if (this.isCenterPosition) {
                    classes.push('center-box');
                } else {
                    classes.push('right');
                }

                return classes.join(' ');
            },
            transition() {
                if (this.isCenterPosition) {
                    return 'slide-down';
                }

                return 'slide-fade';
            },
            isCenterPosition() {
                return this.position === 'center';
            }
        },

        created() {
            EventBus.$on(
                'flash', (message, type) => this.flash(message, type)
            );
        }
    }
</script>

<style lang="scss" scoped>
    .alert-wrap {
        position: fixed;
        z-index: 99995;
        &.right {
            min-width: 300px;
            top: 25px;
            right: 25px;
        }
        &.center-box {
            min-width: 40vw;
            top: 70px;
            left: 50%;
            margin-left: -300px;
            width: 600px
        }
    }

    .alert-wrap .alert {
        border-radius: 0;
    }
    .alert{
        box-shadow: 0px 0px 2px #cfcfcf99;
        font-weight: normal;
        font-style: normal;
        font-size: 14px;
        color: black;
        line-height: 1;
    }
    .alert-succes{
        background: #f6ffee;
    }
    /**
     * Fade transition styles
     */
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */
    {
        opacity: 0
    }

    /**
     * Bounce transition styles
     */
    .bounce-enter-active {
        animation: bounce-in .5s;
    }

    .bounce-leave-active {
        animation: bounce-in .5s reverse;
    }

    @keyframes bounce-in {
        0% {
            transform: scale(0);
        }
        50% {
            transform: scale(1.5);
        }
        100% {
            transform: scale(1);
        }
    }

    /**
     * Slide transition styles
     */
    .slide-fade-enter-active {
        transition: all .3s ease;
    }

    .slide-fade-leave-active {
        transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to {
        transform: translateX(10px);
        opacity: 0;
    }

    /**
     * Slide down styles
     */
    .slide-down-enter-active {
        transition: all .3s ease;
    }

    .slide-down-leave-active {
        transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-down-enter, .slide-down-leave-to {
        transform: translateY(10px);
        opacity: 0;
    }

    @media (max-width: 700px){
        .alert-wrap.center{
            width: 100%;
            left: 0;
            margin-left: 0;
            top: 110px;
        }
    }

</style>
